module.exports = __webpack_public_path__ + "img/main.79797b38.jpg";